import styled, { keyframes } from "styled-components";

export const ModalEvento = styled.div`
  padding: 20px;
  margin: 10px;
  width: 95%;
  backeground:#fff;

  .fade-out {
    animation: fadeOut 20s ease forwards;
  }

  .fade-out-error {
    animation: fadeOut 20s ease forwards;
  }

  @media only screen and (max-width: 500px) {
    padding: 10px;
    margin: 0px;
    width: 90%;
  }
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

export const MsgEvent = styled.div`
  display: flex;
  animation: ${({ showAlert }) => (showAlert ? fadeIn : fadeOut)} 1s ease
    forwards;
    width:100%;
`;

export const MsgEventError = styled.div`
  display: flex;
  animation: ${({ showAlertError }) => (showAlertError ? fadeIn : fadeOut)} 1s
    ease forwards;
`;

export const IconStatus = styled.div`
  width: 33px;
  font-size: 30px;
  text-align: center;
  height: 30px;
  padding: 5px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const Msg = styled.div`
  padding: 12px;
  font-size: 14px;
  font-weight: 300;
  background: #12b600ba;
  color: #ffffff;
  width: 190px;
  text-align: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const MsgShowError = styled.div`
  padding: 12px;
  font-size: 14px;
  font-weight: 300;
  background: red;
  color: #ffffff;
  width: auto;
  text-align: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const BtnSearch = styled.div`
  z-index: 2;
  font-size: 24px;
  position: relative;
  top: 12px;
  right: 10px;
  width: 30px;
  height: 23px;
`;

export const BtnClearInput = styled.div`
border-radius: 12px;
    border-style: none;
    box-sizing: border-box;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    width: 190px;
    line-height: 20px;
    list-style: none;
    margin: 3px;
    outline: none;
    padding: 10px 30px;
    position: relative;
    top: -11px;
    text-align: center;
    text-decoration: none;
    transition: color 100ms;
    vertical-align: baseline;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    background: #aeaeae;
`;

export const BtnSearchEvents = styled.div`
border-radius: 12px;
    border-style: none;
    box-sizing: border-box;
    color: #ffffff;
    cursor: pointer;
    display: inline-block;
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
        width: 200px;
    height: 40px;
    line-height: 20px;
    list-style: none;
    margin: 3px;
    outline: none;
    padding: 10px 30px;
    position: relative;
    top: -11px;
    text-align: center;
    text-decoration: none;
    transition: color 100ms;
    vertical-align: baseline;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    background: #0361a7;
`;

export const Title = styled.div`
  span {
    font-size: 18px;
    font-weight: 700;
  }
`;

export const Subtitle = styled.div`
  margin: 10px 0;
  span {
    font-size: 18px;
    color: #6b6969;
  }
`;

export const ClassError = styled.div`
  padding: 5px;
  color: #ff0000cf;
  font-size: 12px;
`;

export const Container = styled.div`
  display: flex;

  .containerInputs {
    span {
      left: 20px;
      position: relative;
      font-size: 12px;
      color: #504e4e;
    }
  }

  .margin-5{
  margin: 5px;
  }

  .heg-40px{
  height: 40px;
  }

  .selectOption {
    outline: none;
    color: #706f6f;
    padding: 15px 50px;
    font-size: 16px;
    border: 0;
    position: relative;
    border-radius: 8px;
    top: 2px;
    left: 10px;
    margin-bottom: 10px;
    background: transparent;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
  }

  .calendary {
    width: 180px;
    border: none;
    margin-left: 20px;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    padding: 17px;
    outline: none;
    color: #706f6f;
  }

  .mes {
    width: 25px;
    border: none;
    margin-left: 10px;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    padding: 17px;
    outline: none;
    color: #706f6f;
  }

  .ano {
    width: 35px;
    border: none;
    margin-left: 10px;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    padding: 17px;
    outline: none;
    color: #706f6f;
  }

  @media only screen and (max-width: 500px) {
    display: block;
    width: 100%;

    .calendary {
      margin: 5px 0;
      width: 100%;
      box-shadow: none;
      padding: 12px;
    }
  }
`;

export const InputSearch = styled.div`
  width: 350px;
  height: 50px;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;

  .mgErrorId {
    position: relative;
    top: 10px;
    font-size: 12px;
    color: red;
  }

  @media only screen and (max-width: 500px) {
    width: 100%;
    height: 40px;
    box-shadow: none;
    margin: 5px 0;
  }
`;

export const Input = styled.input`
  outline: none;
    color: currentColor;
    padding: 13px;
    font-size: 16px;
    width: 90%;
    border: 0;
    position: relative;
    top: 2px;
    left: 5px;
    margin-bottom: 10px;
    background: transparent;

  @media only screen and (max-width: 500px) {
    width: 100%;
    padding: 8px;
  }
`;

export const Selection = styled.div`
  width: 100px;
  position: relative;
  height: 50px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
  left: 10px;

  @media only screen and (max-width: 500px) {
    width: 100%;
    height: 40px;
    left: 0;
    box-shadow: none;
    margin: 5px 0;

    select {
      width: 100%;
      
    }
  }

  select {
  padding: 6px;
    border: none;
    margin-left: 6px;
    position: relative;
    top: 10px;
    right: 5px;
    font-size: 14px;
    outline: none;
    color: #706f6f;
  }
`;

export const DisplayFlex = styled.div`
  display: flex;
  width: 100%;

  .chekPosition {
    display: flex;
    position: relative;
    top: 32px;
  }

  .colWidth {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 5px;
    font-size: 12px;
  }

  .col {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 5px;
    font-size: 12px;
  }

  .containerBtnEdit {
        width: 100%;
    text-align: right;
  }

  .btnEdit {
    background: #ffc107;
    color: #fff;
  }

  .btnSalvar{
  width: 100%;
    text-align: right;
  }

  .btnEdit:hover {
    background: #fff;
    color: black !important;
    border: 1px solid #ffc107 !important;
  }

  .inputStyled {
    padding: 5px 10px;
    width: 100%;
  }
    .inputStyled.disabled {
  background-color: transparent;
  color:#717171;
  border: none;
  
}

.titleFiled1{
color: #0361a7;
    font-weight: 700;
    font-size: 15px;
}

  @media only screen and (max-width: 500px) {
    display: block;
  }
`;

export const SelectMobile = styled.select`
  padding: 10px;
  width: 100%;
  margin: 10px 0;
  border: none;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
    border-radius: 12px;
`;

export const CardFilterAll = styled.button`
  width: auto;
  height: 40px;
  margin: 30px 5px;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
  rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #fff;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    background: ##005a9e;
  }

  .font-icon-position {
    font-size: 20px;
    margin-right: 10px;
  }

  span {
    font-size: 16px;
    font-weight: 500;
    color: #646464;
  }

  .active {
    background-color: #0361a7;
    color: #ffffff;
  }
`;

export const TextBtn = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: color 0.3s ease;
`;

export const CardFilter = styled.button`
  width: 200px;
  height: 40px;
  margin: 30px 5px;
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
  rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #005a9e;
  transition: background 0.3s ease, color 0.3s ease, border 0.3s ease;

 &:hover {
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    cursor: pointer;
    background: #2e59d9;
    color:#fff;
   border-color: #2653d4;

     ${TextBtn} {
      color: #fff;
    }
  }

  .font-icon-position {
    font-size: 20px;
    margin-right: 10px;
  }

  span {
    font-size: 16px;
    font-weight: 500;
    color: #646464;
  }

  .active {
    background-color: #0361a7;
    color: #ffffff;
  }
`;

export const Table = styled.div`
  width: 100%;
  height: auto;
`;

export const InfoResult = styled.div`
  margin-top: 10px;
  padding: 5px;

  @media only screen and (max-width: 500px) {
    margin-right: 50px;
  }
`;

export const MsgError = styled.div`
  strong {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }

  @media only screen and (max-width: 500px) {
    span {
      font-size: 12px;
    }
  }
`;

export const MsgSucess = styled.div`
  span {
    font-size: 14px;
  }

  @media only screen and (max-width: 500px) {
    span {
      font-size: 12px;
    }
  }
`;

export const CompanyData = styled.div`
  strong {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
`;

const getColorEstadoRReinf = (std, estadosEvento) => {
  if (estadosEvento && estadosEvento.length > 0) {
    estadosEvento.some(evento => evento.text === std)
  }

  switch (true) {
    case std === "Lote processado com sucesso - Todos eventos processados com sucesso.":
      return ["green", "#00800012"];
    case std === "O lote está aguardando processamento.":
      return ["#ffb800", "#ffb8003b"];
    default:
      return ["#ff000f", "#ff00001a"];
  }
};

export const ContaintTableReinf = styled.form`
  width: 100%;
  height: auto;
  margin: 10px 0;
  border-left: 3px solid ${(props) => getColorEstadoRReinf(props.estado, props.estadosEvento)[0]};
  background: ${(props) => getColorEstadoRReinf(props.estado, props.estadosEvento)[1]};
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  color: #646464;

  &:hover {
    background: #fff;
  }

  @media only screen and (max-width: 500px) {
    width: 90%;
    font-size: 12px;
  }
`;

export const Column = styled.div`
  width: 100%;
  margin: 10px;

  .modalEventId {
    float: right;
  }

  .eventId {
    background: ${(props) => getColorEstadoRReinf(props.estado, props.estadosEvento)[0]};
    padding: 5px;
    text-align: center;
    width: 80px;
    position: relative;
    top: -35px;
    right: 10px;
    border-radius: 8px;
    color: #fff;
    font-weight: 700;
  }
`;

export const TitleInfo = styled.div`
  display: flex;
`;

export const InfoEvent = styled.div`
  width: 50%;

  .empresa {
    font-size: 14px;
    position: relative;
    top: -2px;
  }

  .nome {
    color: #383535;
    font-weight: 700;
    font-size: 14px;
  }

  .doc {
    font-size: 14px;
    color: #515151;
  }

  @media only screen and (max-width: 500px) {
    width: 100%;

    .empresa,
    .doc,
    .nome {
      font-size: 12px;
    }
  }
`;

export const DateEvent = styled.div`
  width: 50%;
  span {
    float: right;
    margin-right: 15px;
    font-size: 14px;
  }

  .font-size {
    font-size: 14px;
    position: relative;
    top: 3px;
  }

  @media only screen and (max-width: 500px) {
    span {
      float: none;
      margin-left: 0;
    }

    span,
    .font-size {
      font-size: 12px;
    }
  }
`;

export const Info = styled.div``;

const getColorForStateId = (stateId) => {
  switch (stateId) {
    case 3:
      return ["#006400", "#0064001c"]; // Verde escuro e verde claro
    case 4:
      return ["#ff0000", "#fd000021"]; // Vermelho escuro e vermelho claro
    case 2:
      return ["#fdc100", "#fdc1002b"];
    case 1:
      return ["#7b7b7b", "#7b7b7b0f"];
    case 5:
      return ["#ff0000", "#ff000000"];
    default:
      return ["#989898", "#f8f8f8"]; // Cor padrão e transparência para qualquer outro estado
  }
};

export const Containt = styled.form`
  width: 100%;
  height: auto;
  margin: 10px 0;
  border-left: 3px solid ${(props) => getColorForStateId(props.estadoId)[0]};
  background: ${(props) => getColorForStateId(props.estadoId)[1]};
  box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  color: #646464;

  &:hover {
    background: #fff;
  }

  @media only screen and (max-width: 500px) {
    width: 90%;
    font-size: 12px;
  }
`;

export const BtnArquivar = styled.div`
  text-align: center;
  .position-font {
    position: relative;
    top: 20px;
    font-size: 24px;
  }
`;

export const PaginationBtn = styled.div`
  width: 100%;
  margin: 18px 0;
`;

export const MsgErrorSearsh = styled.div`
  background: #f4f4f4;
  text-align: center;
  color: black;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

export const MsgErrorService = styled.div`
  padding: 10px;

  .fontSizeProgressCicle {
    font-size: 10px;
  }
`;

export const ModalListNFE = styled.div`
  width: 320px;
  margin: 5px;
  height: 470px;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: rgb(255 255 255);
  transition: opacity 8.5s ease, visibility 6.5s ease;
  padding: 20px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;

  .title {
    padding: 10px;

    label {
      color: #0361a7;
    }

    span {
      position: relative;
      top: 5px;
      color: #898989;
    }
  }

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`;

export const ContainerDadosListNFE = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  margin-top: 5px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

  .titleText {
    font-size: 14px;
    color: #0361a7;
        margin-bottom: 20px;
  }

  .iconFont {
    font-size: 38px;
    color: #0361a7;
  }

  .value {
    font-size: 22px;
    color: #36444c;

    span {
      position: relative;
      top: 17px;
      left: 5px;
    }
  }

  .iconFontOlho {
        font-size: 38px;
    color: #36444c;
    width: 100px;
    text-align: center;
  }
`;

export const IconOlho = styled.div`
padding: 5px;
    width: 100%;
    text-align: right;
    font-size: 26px;
    position: relative;
    right: 8px;
    color: #36444c;
`;

export const ModalCreate = styled.div`
    width: 500px;
    margin: 5px;
    height: 550px;
    border-radius: 20px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background-color: #ffffff;
    transition: opacity 8.5s, visibility 6.5s;
    padding: 20px;
    box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
    overflow: hidden auto;

  .title {
    padding: 10px;

    label {
      color: #504f4f;
    }

    span {
      position: relative;
      top: 5px;
      color: #898989;
    }
  }

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`;

export const ModalEvent = styled.div`
  width: 720px;
  margin: 5px;
  height: 400px;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: rgb(255 255 255 / 68%);
  transition: opacity 8.5s ease, visibility 6.5s ease;
  backdrop-filter: blur(22px);
  padding: 20px;
  box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset,
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;

  .title {
    padding: 10px;

    label {
      color: #504f4f;
    }

    span {
      position: relative;
      top: 5px;
      color: #898989;
    }
  }

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media only screen and (max-width: 500px) {
    left: 40%;
    width: 200px;
    height: 500px;
    padding: 15px;
    font-size: 12px !important;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vw;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: opacity 0.5s ease, visibility 0.5s ease;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const Close = styled.div`
  padding: 5px;
  width: 100%;
  text-align: right;

  .font-icon {
    font-size: 35px;
    color: #838383;
    cursor: pointer;
  }
`;

export const Col = styled.div`
  margin: 5px;
  padding: 10px;

  .colorError {
    background: #ff000038;
  }

  .colorSucess {
    background: #007c0047;
    color: #3b3a3a;
  }

  .colorFila {
    color: #88888c47;
  }

  .colorProcess {
    color: #ffa60047;
  }

  .eventoStatus {
    margin-top: 10px;
    padding: 12px;
    text-align: center;
    border-radius: 30px;
    font-weight: 700;
  }

  .idEvent {
    text-align: center;
    color: #6f6a6a;
    margin-top: 5px;
  }
`;

export const Details = styled.details`
  padding: 10px;

  ul li span {
    color: #666666;
  }

  ul {
    padding: 0;
  }

  ul li {
    list-style-type: none;
    padding: 0;
  }

  ul li input {
    color: red;
    padding: 5px;
    margin-top: 10px;
    border-radius: 12px;
    width: 100%;
  }

  ul li p {
    color: red;
  }

  ul li p span {
    color: red;
  }
`;

export const Summary = styled.summary`
  font-weight: 700;
  color: #3a3a3a;
`;

export const SpanInfo = styled.span`
  color: #3d7aa8;
  font-weight: 700;
`;

export const Modal = styled.div`
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);

  .modal-content {
    animation-name: modalopen;
    animation-duration: 0.3s;
  }

  @keyframes modalopen {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-out {
    animation-name: modalclose;
    animation-duration: 0.3s;
  }
`;

export const ModalContent = styled.div`
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);

  .modal-content {
    animation-name: modalopen;
    animation-duration: 0.3s;
  }

  @keyframes modalopen {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .fade-out {
    animation-name: modalclose;
    animation-duration: 0.3s;
  }
`;

export const EstadoEventMsg = styled.div`
  padding: 15px 0;
  background: transparent;
  border-radius: 4px;

  span {
    margin-left: 10px;
  }
`;

export const ContainerModal = styled.div`
  display: flex;
    border-radius: 8px;
    background: #ffffffab;

  .bgColorFont {
    font-size: 16px;
    font-weight: 700;
    color: #979797;
  }

  .container-prev {
  width: 50%;
    .prev {
      padding: 10px;
      width: 100px;
      margin: 2px;
    }
  }

  .container-next {
  width: 50%;
    .next {
      padding: 10px;
      width: 100px;
      margin: 2px;
      float: right;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const InfoItem = styled.span`
  margin-bottom: 10px;

  .titulo {
    padding: 10px 0;
    color: #999999;
    font-size: 18px;
    font-weight: 300;
  }

  .btnRetransmitir {
    width: 200px;
    text-align: center;
    float: right;
    cursor: pointer;
  }

  .servicoDiscr {
    margin-bottom: 10px;
    background: #3498db21;
    padding: 10px;
    border-radius: 4px;
    box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px,
      rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
    border-left: 3px solid;
  }

  .moreInfo {
    font-size: 15px;
    color: #4e4e4e;
  }

  .tituloLabel {
    color: #0361a7;
    font-weight: 700;
    font-size: 15px;
  }

  .error {
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 5px 10px;
    background: #ff0000;
    color: #fff;
    width: 100px;
    text-align: center;
    font-size: 18px;
  }
  .sucess {
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 5px 10px;
    color: #fff;
    width: 100%;
    text-align: center;
    font-size: 18px;
    background: #07bc0ccc;
  }

  .container-input-field{

  }

  &:last-of-type {
    margin-bottom: 20px;
  }


`;

export const ArrayDetails = styled.details`
  margin-bottom: 10px;
`;

export const ArraySumarry = styled.summary`
  cursor: pointer;
`;

export const ColumnIntem = styled.div`
  flex: 1;
  min-width: 200px;
  padding: 10px;

  @media (min-width: 768px) {
    &:nth-child(odd) {
      margin-right: 10px;
    }
  }
`;

export const BtnCreate = styled.div`
   display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px;
    border-radius: 30px;
    box-shadow: rgb(0 0 0 / 4%) 0px 2px 4px;
    background: #008000d6;
    position: relative;
    top: 1px;
    color: #fff;
    font-weight: 700;
    font-size: 28px;
    cursor: pointer;
    height: 29px;
    width: 29px;
`;

export const ContainerBtnCreate = styled.div`
  display: flex;
  align-items: center;
  height: 45px;
  width: 100%;
  position: relative;
  top: 0;

  span {
    padding: 10px;
    color: #7a7a7a;
    opacity: 0;
    transform: translateX(-20px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    position: relative;
    top: 0px;
  }

  &:hover span {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const SelectOption = styled.div`
  position: relative;
  display: inline-block;
  width: 200px;
  color: #706f6f;
`;

export const OptionItem = styled.div`
  padding: 10px;
    cursor: pointer;
    background: rgb(229, 246, 253);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    margin: 10px;
    border-radius: 8px;
    color: #706f6f;

  &:hover {
    background: #f0f0f0;
  }
`;

export const OptionsList = styled.div`
  position: absolute;
    width: 90%;
    left: 10px;
    border-top: none;
    max-height: 150px;
    overflow-y: auto;
    z-index: 1000;
    background-color: rgb(255 255 255 / 68%);
    transition: opacity 8.5s ease, visibility 6.5s ease;
    backdrop-filter: blur(22px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    border-radius: 8px;
    margin-top:5px;
`;

export const SelectedItem = styled.div`
    padding: 16px 20px;
    border: none;
    background: white;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: rgb(0 0 0 / 4%) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
    margin: 0 10px;
`;

export const SelectArrow = styled.span`
  float: right;
`;

export const ContainerExport = styled.div`
`;

export const IconExe = styled.div`
    float: right;
    font-size: 30px;
    position: relative;
    top: 25px;
    margin-left: 20px;
    cursor: pointer;

    &:hover {
      color: #006300;
    }
`;

export const ProgressExport = styled.div`
  .cicleProgress {
    margin: 0px 5px;
    position: relative;
    top: 20px;
  }
`;

export const InputText = styled.input`
    outline: none;
    color: #727272;
    padding: 13px;
    font-size: 16px;
    border: 0;
    width: 95%;
    height: 18px;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: rgb(0 0 0 / 0%) 0px 15px 25px, rgb(0 0 0 / 2%) 0px 5px 10px;
    background: #f4f4f4;
`;

export const ColumnFlex = styled.div`
  display: flex;
`;

export const ColumnInput = styled.div`
  margin: 5px;
  display: flex;
  flex-direction: column;

  .checkBoxValue {
    span {
      font-size: 16px;
      font-weight: 300;
      color: #9a9a9a;
    }
  }

  .select {
    outline: none;
    color: #706f6f;
    padding: 12px 50px;
    font-size: 16px;
    border: 0;
    position: relative;
    border-radius: 4px;
    top: 2px;
    margin-bottom: 10px;
    box-shadow: rgb(0 0 0 / 0%) 0px 15px 25px, rgb(0 0 0 / 2%) 0px 5px 10px;
    background: #f4f4f4;
  }

  .titleSpan {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 300;
    color: #777777;
  }
`;

export const ColumnInputs = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  width: 100%;
`;

export const ColumnContainer = styled.div`
  display: flex;
`;

export const ContainerModalMain = styled.div`
  width: 100%;
  backeground:#fff;
`;
